<template>
    <div v-if="!childs || childs.length > 0" class="acc__item" :class="{ 'acc__item--active': itemToggled }">
        <div @click="toggleItem">
            <slot name="bar"></slot>
        </div>

        <transition
            name="accordion-item"
            @before-enter="beforeEnter"
            @enter="enter"
            @after-enter="afterEnter"
            @before-leave="beforeLeave"
            @leave="leave"
            @after-leave="afterLeave"
        >
            <div v-if="itemToggled" class="acc__item__details">
                <slot name="content"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    import { ref, watch } from 'vue';

    export default {
        props: {
            shouldOpen: {
                type: Boolean,
                required: false,
                default: false,
            },
            item: {
                type: Object,
                required: true,
            },
            enableCheckbox: {
                type: Boolean,
                required: false,
            },
            childs: {
                type: Array,
                required: false,
            },
        },
        emits: ['isClosing', 'isOpening'],
        setup(props, { emit }) {
            // eslint-disable-next-line vue/no-setup-props-destructure
            const { item, shouldOpen } = props;
            const itemToggled = ref(!!shouldOpen);
            const toggleItem = () => {
                itemToggled.value = !itemToggled.value;
                if (itemToggled.value) {
                    emit('isOpening', item);
                } else {
                    emit('isClosing', item);
                }
                return itemToggled.value;
            };

            watch(
                () => props.shouldOpen,
                (newVal) => {
                    itemToggled.value = newVal;
                }
            );

            const beforeEnter = (el) => {
                el.style.height = '0';
                el.style.overflow = 'hidden';
            };

            const enter = (el) => {
                el.style.height = `${el.scrollHeight}px`;
            };

            const afterEnter = (el) => {
                el.style.height = 'auto';
                el.style.overflow = '';
            };

            const beforeLeave = (el) => {
                el.style.height = `${el.scrollHeight}px`;
                el.style.overflow = 'hidden';
            };

            const leave = (el) => {
                el.style.height = '0';
            };

            const afterLeave = (el) => {
                el.style.height = '';
                el.style.overflow = '';
            };

            return {
                itemToggled,
                toggleItem,
                beforeEnter,
                enter,
                afterEnter,
                beforeLeave,
                leave,
                afterLeave,
            };
        },
    };
</script>
